export default __webpack_public_path__ + "static/media/xeonide_thumb.29513aed.png";